import { enumKeySource } from "../constants";
import { QRFCMgr } from "./QRFCMgr";
import { QTimerMgr } from "./QTimerMgr";
import { Globals } from "./Globals";

export class QApp {
  constructor() {
    //this.fDocuments = [];
    this.fWSMgr = null;
    this.isFixedWindow = null;
  }

  GetDefaultWindowWidth() {
    return Globals._mobileDevice ? 300 : 600;
  }

  GetDefaultWindowHeight() {
    return Globals._mobileDevice ? 250 : 400;
  }

  InitApp(wsMgr) {
    this.fWSMgr = wsMgr;
    Globals._timerMgr = new QTimerMgr();
    Globals._timerMgr.InitTimerMgr(wsMgr);

    Globals._rfcMgr = new QRFCMgr();
    Globals._rfcMgr.InitRFCMgr();
    Globals._rfcMgr.fWSMgr = wsMgr;
  }

  // Run the application
  RunApp() {
    this.fWSMgr.RenderWS();
  }

  // Hover behavior
  HandleMouseMove(x, y) {
    this.fWSMgr.HandleMouseMove(x, y);
  }

  // Mouse DoubleClick
  HandleDoubleClick(x, y) {
    this.fWSMgr.HandleDoubleClick(x, y);
  }

  // Mouse down
  HandleMouseDown(x, y) {
    Globals._mouseUpHandled = false;
    //	window.addEventListener('mouseup', handleAppMouseUp, false);
    this.fWSMgr.HandleMouseDown(x, y);
  }

  // Mouse up
  HandleMouseUp(x, y, event, canvas) {
    Globals._mouseUpHandled = true;
    this.fWSMgr.HandleMouseUp(x, y, event, canvas);
  }

  // Mouse up - outside of application canvas
  HandleMouseEnter(x, y) {
    this.fWSMgr.HandleMouseEnter(x, y);
  }

  HandleRightClick(x, y, event) {
    this.fWSMgr.HandleRightClick(x, y, event);
  }

  // Add a document to the app
  HandlePaste(theContent) {
    this.fWSMgr.HandlePaste(theContent);
  }

  HandleCopy(theEvent) {
    this.fWSMgr.DoCutCopy(theEvent, false);
  }

  HandleCut(theEvent) {
    this.fWSMgr.DoCutCopy(theEvent, true);
  }

  //=================================================================================================
  // Keyboard handling
  HandleKeyboard(event, keySource) {
    return this.fWSMgr.HandleKeyboard(event, keySource, null);
  }

  HandleMobileKeyboard(event, keyboardInfo) {
    return this.fWSMgr.HandleKeyboard(event, enumKeySource.keyPress, keyboardInfo);
  }

  HandleKeyUp(event) {
    this.fWSMgr.HandleKeyUp(event);
  }

  //=================================================================================================
  // Window Resize
  HandleResize(event, includeSidebar = true) {
    var fallbackWidth = this.GetDefaultWindowWidth();
    var fallbackHeight = this.GetDefaultWindowHeight();

    var appContainer = document.querySelector(".appContainer");
    var sideBar = includeSidebar ? document.querySelector(".ocn-right-sidebar") : null;
    var navBar = document.querySelector(".mainNav");
    var appHeader =
      document.querySelector(".appHeader") || document.querySelector(".appHeader--modal");
    var contextualToobar = document.querySelector(".contextToolbar");
    var phoneToolbar = document.querySelector(".ocn-phone-toolbar");

    var shellWidth = appContainer ? appContainer.offsetWidth : 0;
    var shellHeight = appContainer ? appContainer.offsetHeight : 0;

    // Floored at 1px only so the canvas backbuffer is never zero-sized.
    var containerWidth = shellWidth
      ? Math.max(
          1,
          shellWidth - (navBar ? navBar.offsetWidth : 0) - (sideBar ? sideBar.offsetWidth : 0)
        )
      : fallbackWidth;
    var containerHeight = shellHeight
      ? Math.max(
          1,
          shellHeight -
            (appHeader ? appHeader.offsetHeight : 0) -
            (contextualToobar ? contextualToobar.offsetHeight : 0) -
            (phoneToolbar ? phoneToolbar.offsetHeight : 0)
        )
      : fallbackHeight;

    const canvasContainer = document.getElementById("canvasContainer");
    canvasContainer.style.width = containerWidth + "px";
    canvasContainer.style.height = containerHeight + "px";

    if (contextualToobar) contextualToobar.style.width = containerWidth + "px";

    const rect = canvasContainer.getBoundingClientRect();
    var newWidth = Math.ceil(Math.max(1, rect.width || containerWidth));
    var newHeight = Math.ceil(Math.max(1, rect.height || containerHeight));

    this.fWSMgr.HandleResize(newWidth, newHeight, true);

    this.fWSMgr.BroadcastTopic("BoundaryChange");
  }

  HandleMouseWheel(direction, event) {
    this.fWSMgr.HandleMouseWheel(direction, event);
  }

  HandleGesture(event) {
    this.fWSMgr.HandleGesture(event);
  }

  HandleTouch(event) {
    this.fWSMgr.HandleTouch(event);
  }

  ConfirmExit() {
    return this.fWSMgr.ConfirmExit();
  }

  HandleAutoLogin() {
    return this.fWSMgr.HandleAutoLogin();
  }

  //=============================================
  // Drag and Drop File Upload
  HandleFiles(event, x, y) {
    this.fWSMgr.CloseDragAndDropBox();
    var dropZoneElement = document.querySelector(".oc-file-drop-zone");
    var wsMgr = this.fWSMgr;
    var targetPanel = wsMgr.GetKeyboardTargetPanel();
    var dropTarget = wsMgr.FindActualDropTarget(x, y);
    var dropInfo = targetPanel.GetDropInfo();
    var dropDirectory = dropInfo["dropDirectory"];
    var dropRestrictions = dropInfo["dropRestrictions"];
    var allowMulti = event.currentTarget === dropZoneElement;
    this.fWSMgr.HandleFiles(event, dropDirectory, dropRestrictions, allowMulti, dropTarget);
  }

  StartDragAndDrop(event, x, y) {
    this.fWSMgr.InitDragAndDropBox(event, x, y);
  }

  EndDragAndDrop(event, x, y) {
    this.fWSMgr.CloseDragAndDropBox(event, x, y);
  }

  //=================================================================================================
  // PrepHandleEvent
  PrepHandleEvent(mouseMoveEvent, x, y) {
    return this.fWSMgr.PrepHandleEvent(mouseMoveEvent, x, y);
  }

  SetIsFixedWindow() {
    this.isFixedWindow = true;
  }
}
